/* File: assets/custom-wishlist-page.js */

(function () {
  'use strict';

  var storageKey = 'archetype_wishlist_variants_v1';
  var productCache = Object.create(null);
var productFilterDataCache = Object.create(null);

  function numericId(value) {
    return String(value || '').split('/').pop().split('?')[0];
  }

  function rootUrl() {
    var config = window.CartWishlistConfig || {};
    var root =
      config.routesRoot ||
      (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ||
      '/';

    return root.endsWith('/') ? root : root + '/';
  }

  function productUrl(handle) {
    return rootUrl() + 'products/' + encodeURIComponent(handle || '');
  }

  function readStoredItems() {
    try {
      var parsed = JSON.parse(window.localStorage.getItem(storageKey) || '[]');
      if (!Array.isArray(parsed)) return [];

      return parsed
        .filter(function (item) {
          return item && item.handle && item.variantId;
        })
        .map(function (item) {
          return {
            handle: String(item.handle),
            variantId: String(item.variantId)
          };
        });
    } catch (error) {
      console.warn('[wishlist-page] Could not read wishlist storage.', error);
      return [];
    }
  }

  function getWishlistItems() {
    var api = window.CartWishlistDrawer;

    if (api && typeof api.getItems === 'function') {
      return api.getItems();
    }

    return readStoredItems();
  }

  function fetchProduct(handle) {
  if (productCache[handle]) return Promise.resolve(productCache[handle]);

  return fetch(productUrl(handle) + '.js', {
    credentials: 'same-origin',
    headers: { Accept: 'application/json' }
  })
    .then(function (response) {
      if (!response.ok) throw new Error('Could not load product: ' + handle);
      return response.json();
    })
    .then(function (product) {
      productCache[handle] = product;
      return product;
    });
}
function fetchProductFilterData(handle) {
  if (productFilterDataCache[handle]) {
    return Promise.resolve(productFilterDataCache[handle]);
  }

  return fetch(
    productUrl(handle) + '?section_id=wishlist-product-filter-data',
    {
      credentials: 'same-origin',
      headers: { Accept: 'text/html' }
    }
  )
    .then(function (response) {
      if (!response.ok) {
        throw new Error(
          'Could not load wishlist filter data: ' + handle
        );
      }

      return response.text();
    })
    .then(function (html) {
      var renderedDocument = new DOMParser().parseFromString(
        html,
        'text/html'
      );

      var script = renderedDocument.querySelector(
        '[data-wishlist-product-filter-data]'
      );

      var data = script
        ? JSON.parse(script.textContent || '{}')
        : {};

      data.category = String(
        data.category || ''
      ).trim();

      productFilterDataCache[handle] = data;

      return data;
    })
    .catch(function (error) {
      console.warn(
        '[wishlist-page] Category data unavailable for ' +
          handle +
          '.',
        error
      );

      var fallback = {
        category: ''
      };

      productFilterDataCache[handle] = fallback;

      return fallback;
    });
}

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>'"]/g, function (character) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        "'": '&#039;',
        '"': '&quot;'
      }[character];
    });
  }

  function money(cents) {
    var value = Number(cents || 0) / 100;
    var config = window.CartWishlistConfig || {};

    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: config.currency || 'USD',
        maximumFractionDigits: value % 1 === 0 ? 0 : 2
      }).format(value);
    } catch (error) {
      return '$' + value.toFixed(value % 1 === 0 ? 0 : 2);
    }
  }

  function optionNames(product) {
    return (product.options || []).map(function (option) {
      return typeof option === 'string' ? option : option && option.name ? option.name : '';
    });
  }

  function optionIndex(product, candidates) {
    return optionNames(product).findIndex(function (name) {
      var normalized = String(name || '').toLowerCase();
      return candidates.some(function (candidate) {
        return normalized.indexOf(candidate) !== -1;
      });
    });
  }

  function variantOptions(variant) {
    if (variant && Array.isArray(variant.options)) return variant.options;

    return [variant && variant.option1, variant && variant.option2, variant && variant.option3].filter(
      function (value) {
        return value != null && value !== '';
      }
    );
  }

  function variantById(product, variantId) {
    var id = numericId(variantId);

    return (
      (product.variants || []).find(function (variant) {
        return String(variant.id) === String(id);
      }) || null
    );
  }

  function firstAvailableVariant(product) {
    return (
      (product.variants || []).find(function (variant) {
        return variant.available !== false;
      }) ||
      (product.variants || [])[0] ||
      null
    );
  }

  function selectedVariant(product, variantId) {
    return variantById(product, variantId) || firstAvailableVariant(product);
  }

  function imageUrl(image) {
    if (!image) return '';
    if (typeof image === 'string') return image;
    return image.src || image.url || '';
  }

  function tags(product) {
    if (Array.isArray(product.tags)) return product.tags.map(String);
    if (typeof product.tags === 'string') {
      return product.tags
        .split(',')
        .map(function (tag) {
          return tag.trim();
        })
        .filter(Boolean);
    }
    return [];
  }

  function normalizedTag(tag) {
    return String(tag || '')
      .toLowerCase()
      .replace(/[-_/]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function isNewTag(tag) {
    var value = normalizedTag(tag);
    return value === 'new' || value === 'new arrival' || value === 'new arrivals';
  }

  function productAvailable(product) {
    if (typeof product.available === 'boolean') return product.available;

    return (product.variants || []).some(function (variant) {
      return variant.available !== false;
    });
  }

  function productLabel(product) {
    if (!productAvailable(product)) {
      return { text: 'OUT OF STOCK', soldOut: true };
    }

    var productTags = tags(product);
    if (productTags.some(isNewTag)) return { text: 'NEW', soldOut: false };

    var firstTag = productTags[0] || '';
    return {
      text: firstTag.replace(/[-_/]+/g, ' ').trim(),
      soldOut: false
    };
  }

  function selectedColour(product, variant) {
    var index = optionIndex(product, ['color', 'colour']);
    var options = variantOptions(variant);
    return index > -1 ? options[index] || '' : '';
  }
function productCategoryColour(product, variant) {
  var category = String(
    product.type || ''
  ).trim();

  var colour = String(
    selectedColour(product, variant) || ''
  ).trim();

  return [category, colour]
    .filter(Boolean)
    .join(' • ');
}
  function getSizeData(product, variant) {
    var colorIndex = optionIndex(product, ['color', 'colour']);
    var sizeIndex = optionIndex(product, ['size']);
    var names = optionNames(product);

    if (sizeIndex < 0) {
      sizeIndex = names.findIndex(function (name, index) {
        return index !== colorIndex && String(name || '').trim() !== '';
      });
    }

    var selectedOptions = variantOptions(variant);
    var matching = (product.variants || []).filter(function (candidate) {
      var options = variantOptions(candidate);

      return selectedOptions.every(function (selectedValue, index) {
        if (index === sizeIndex) return true;
        return options[index] === selectedValue;
      });
    });

    var choices = new Map();

    matching.forEach(function (candidate) {
      var options = variantOptions(candidate);
      var label = sizeIndex > -1 ? options[sizeIndex] : '';

      if (!label || label === 'Default Title') label = 'One Size';

      var existing = choices.get(label);
      if (!existing || String(candidate.id) === String(variant.id)) {
        choices.set(label, candidate);
      }
    });

    if (!choices.size) {
      choices.set('One Size', variant);
    }

    return {
      sizeIndex: sizeIndex,
      choices: choices
    };
  }

  function heartIcon() {
    return [
      '<svg viewBox="0 0 24 24" aria-hidden="true">',
      '<path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78L12 21.23l7.78-7.78a5.5 5.5 0 0 0 1.06-7.78Z"/>',
      '</svg>'
    ].join('');
  }

function bagIcon() {
  var api = window.CartWishlistDrawer;

  if (
    api &&
    typeof api.createIcon === 'function'
  ) {
    return api.createIcon('bag');
  }

  return [
    '<svg viewBox="0 0 24 24" aria-hidden="true">',
    '<path d="M6.4 8.2h11.2l1 12H5.4l1-12Z"/>',
    '<path d="M9 8.2V6.4a3 3 0 0 1 6 0v1.8" fill="none" stroke="currentColor" stroke-width="1.5"/>',
    '</svg>'
  ].join('');
}

function menuBagIcon() {
  return bagIcon();
}

  function trashIcon() {
    return [
      '<svg viewBox="0 0 24 24" aria-hidden="true">',
      '<path d="M4 7h16M9 7V4h6v3m3 0-1 13H7L6 7m4 4v6m4-6v6" fill="none" stroke="currentColor" stroke-width="1.5"/>',
      '</svg>'
    ].join('');
  }

  function unique(values) {
    return Array.from(new Set(values.filter(Boolean)));
  }

  function genderValues(product) {
    var results = [];

    tags(product).forEach(function (tag) {
      var value = normalizedTag(tag);
      if (/^(men|mens|men's|male)$/.test(value)) results.push('Men');
      if (/^(women|womens|women's|female)$/.test(value)) results.push('Women');
      if (value === 'unisex') results.push('Unisex');
    });

    return unique(results);
  }

  function fitValues(product) {
    var results = [];
    var fitIndex = optionIndex(product, ['fit']);

    if (fitIndex > -1) {
      (product.variants || []).forEach(function (variant) {
        results.push(variantOptions(variant)[fitIndex]);
      });
    }

    tags(product).forEach(function (tag) {
      var value = normalizedTag(tag);
      if (/\bfit\b/.test(value)) results.push(String(tag));
    });

    return unique(results);
  }

  function activityValues(product) {
    var activityPattern = /\b(running|run|training|lifting|gym|yoga|pilates|rest day|conditioning|cycling|hiking|swim|swimming|sports)\b/i;

    return unique(
      tags(product).filter(function (tag) {
        return activityPattern.test(normalizedTag(tag));
      })
    );
  }

  function featureValues(product) {
    var gender = genderValues(product).map(normalizedTag);
    var fits = fitValues(product).map(normalizedTag);
    var activities = activityValues(product).map(normalizedTag);

    return unique(
      tags(product).filter(function (tag) {
        var value = normalizedTag(tag);

        return (
          value &&
          value.charAt(0) !== '_' &&
          !isNewTag(tag) &&
          gender.indexOf(value) === -1 &&
          fits.indexOf(value) === -1 &&
          activities.indexOf(value) === -1
        );
      })
    );
  }

  function allOptionValues(product, candidates) {
    var index = optionIndex(product, candidates);
    if (index < 0) return [];

    return unique(
      (product.variants || []).map(function (variant) {
        return variantOptions(variant)[index];
      })
    );
  }

function filterValuesForProduct(product, filterData) {
  var category = String(
    (filterData && filterData.category) || ''
  ).trim();

  return {
    size: allOptionValues(product, ['size']),

    color: allOptionValues(
      product,
      ['color', 'colour']
    ),

    availability: [
      productAvailable(product)
        ? 'In stock'
        : 'Out of stock'
    ],

    category: category
      ? [category]
      : []
  };
}

  function compareStrings(a, b) {
    return String(a || '').localeCompare(String(b || ''), undefined, {
      sensitivity: 'base',
      numeric: true
    });
  }
  function normalizeSizeValue(value) {
  return String(value || '')
    .trim()
    .toUpperCase()
    .replace(/\s+/g, '')
    .replace(/[-_]/g, '');
}

function sizeSortRank(value) {
  var normalized = normalizeSizeValue(value);

  var knownSizes = {
    '3XS': 10,
    XXXS: 10,
    '2XS': 20,
    XXS: 20,

    XS: 30,
    XSMALL: 30,
    EXTRASMALL: 30,

    S: 40,
    SMALL: 40,

    M: 50,
    MEDIUM: 50,

    L: 60,
    LARGE: 60,

    XL: 70,
    '1XL': 70,
    XLARGE: 70,
    EXTRALARGE: 70,

    '2XL': 80,
    XXL: 80,
    '2XLARGE': 80,
    XXLARGE: 80,
    EXTRAEXTRALARGE: 80,

    '3XL': 90,
    XXXL: 90,
    '3XLARGE': 90,
    XXXLARGE: 90,

    '4XL': 100,
    XXXXL: 100,
    '4XLARGE': 100,

    '5XL': 110,
    '5XLARGE': 110,

    '6XL': 120,
    '6XLARGE': 120,

    ONESIZE: 1000,
    OS: 1000,
    OSFA: 1000,
    ONESIZEFITSALL: 1000
  };

  if (
    Object.prototype.hasOwnProperty.call(
      knownSizes,
      normalized
    )
  ) {
    return knownSizes[normalized];
  }

  /*
   * Support additional sizes such as 7XL or 8XL.
   */
  var numberedExtraLarge =
    normalized.match(/^(\d+)XL(?:ARGE)?$/);

  if (numberedExtraLarge) {
    return (
      60 +
      Number(numberedExtraLarge[1]) * 10
    );
  }

  /*
   * Preserve natural ordering for numeric sizes:
   * 28, 30, 32, 34, etc.
   */
  var numericSize =
    normalized.match(/^\d+(?:\.\d+)?$/);

  if (numericSize) {
    return 200 + Number(normalized);
  }

  /*
   * Unknown labels remain after recognized sizes.
   */
  return 900;
}

function compareSizes(a, b) {
  var rankDifference =
    sizeSortRank(a) -
    sizeSortRank(b);

  if (rankDifference !== 0) {
    return rankDifference;
  }

  return compareStrings(a, b);
}

  function WishlistPage(root) {
    this.root = root;
    this.grid = root.querySelector('[data-wlp-grid]');
    this.results = root.querySelector('[data-wlp-results]');
    this.sidebar = root.querySelector(
  '[data-wlp-sidebar]'
);

this.activeFilterBar =
  root.querySelector(
    '[data-wlp-active-filters]'
  );
    this.loading = root.querySelector('[data-wlp-loading]');
    this.empty = root.querySelector('[data-wlp-empty]');
    this.noResults = root.querySelector('[data-wlp-no-results]');
    this.count = root.querySelector('[data-wlp-heading-count]');
this.mobileCount = root.querySelector('[data-wlp-mobile-count]');
this.mobileControls = root.querySelector('[data-wlp-mobile-controls]');
this.mobileUi = root.querySelector('aac-mobile-wishlist-ui');
this.clearButton = root.querySelector('[data-wlp-clear-all]');
this.dynamicFiltersBeforePrice =
  root.querySelector(
    '[data-wlp-dynamic-filters-before-price]'
  );

this.dynamicFiltersAfterPrice =
  root.querySelector(
    '[data-wlp-dynamic-filters-after-price]'
  );
    this.priceMin = root.querySelector('[data-wlp-price-min]');
    this.priceMax = root.querySelector('[data-wlp-price-max]');
this.priceCount = root.querySelector(
  '[data-wlp-price-count]'
);

    this.entries = [];
    this.activeFilters = Object.create(null);
    this.sort = 'relevance';
    this.priceTimer = 0;
    this.refreshToken = 0;

    this.onClick = this.onClick.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onInput = this.onInput.bind(this);
    this.onWishlistUpdate = this.onWishlistUpdate.bind(this);
    this.onStorage = this.onStorage.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);

    this.root.addEventListener('click', this.onClick);
    this.root.addEventListener('change', this.onChange);
    this.root.addEventListener('input', this.onInput);
    this.onDocumentClick = this.onDocumentClick.bind(this);
    document.addEventListener('click', this.onDocumentClick);
    document.addEventListener('keydown', this.onKeyDown);
    document.addEventListener('wishlist:updated', this.onWishlistUpdate);
    window.addEventListener('storage', this.onStorage);

    this.refresh();
  }

  WishlistPage.prototype.destroy = function () {
    this.root.removeEventListener('click', this.onClick);
    this.root.removeEventListener('change', this.onChange);
    this.root.removeEventListener('input', this.onInput);
    document.removeEventListener('click', this.onDocumentClick);
    document.removeEventListener('keydown', this.onKeyDown);
    document.removeEventListener('wishlist:updated', this.onWishlistUpdate);
    window.removeEventListener('storage', this.onStorage);
  };

WishlistPage.prototype.setState =
  function (name) {
    var showSidebar =
      name === 'grid' ||
      name === 'no-results';

    this.loading.hidden =
      name !== 'loading';

    this.empty.hidden =
      name !== 'empty';

    this.noResults.hidden =
      name !== 'no-results';

    this.grid.hidden =
      name !== 'grid';

if (this.sidebar) {
  this.sidebar.hidden = !showSidebar;
}

if (this.mobileControls) {
  this.mobileControls.hidden = !showSidebar;
}

if (
  !showSidebar &&
  this.mobileUi &&
  typeof this.mobileUi.closeSheet === 'function'
) {
  this.mobileUi.closeSheet(false, true);
}

    this.root.classList.toggle(
      'wlp--without-sidebar',
      !showSidebar
    );

    this.root.classList.toggle(
      'wlp--has-products',
      showSidebar
    );

    this.results.setAttribute(
      'aria-busy',
      name === 'loading'
        ? 'true'
        : 'false'
    );
  };

WishlistPage.prototype.updateCount = function (count) {
  if (this.count) {
    this.count.textContent =
      count + (count === 1 ? ' Product' : ' Products');
  }

  if (this.mobileCount) {
    this.mobileCount.textContent =
      count + (count === 1 ? ' product' : ' products');
  }
};

  WishlistPage.prototype.refresh = function () {
    var self = this;
    var token = ++this.refreshToken;
    var items = getWishlistItems();

    this.setState('loading');
    this.updateCount(items.length);

if (!items.length) {
  this.entries = [];

  if (this.dynamicFiltersBeforePrice) {
    this.dynamicFiltersBeforePrice.innerHTML = '';
  }

  if (this.dynamicFiltersAfterPrice) {
    this.dynamicFiltersAfterPrice.innerHTML = '';
  }

  this.grid.innerHTML = '';
  this.resetFilters(false);
  this.setState('empty');

  return;
}

    Promise.all(
      items.map(function (item, index) {
return Promise.all([
  fetchProduct(item.handle),
  fetchProductFilterData(item.handle)
])
  .then(function (results) {
    var product = results[0];
    var filterData = results[1];

    return {
      item: item,
      product: product,
      filterData: filterData,
      variant: selectedVariant(
        product,
        item.variantId
      ),
      originalIndex: index
    };
  })
          .catch(function (error) {
            console.warn('[wishlist-page] Skipping unavailable product.', error);
            return null;
          });
      })
    ).then(function (entries) {
      if (token !== self.refreshToken || !self.root.isConnected) return;

      self.entries = entries.filter(function (entry) {
        return entry && entry.product && entry.variant;
      });

      self.entries.forEach(function (entry) {
        entry.filters = filterValuesForProduct(
  entry.product,
  entry.filterData
);
      });

      self.pruneActiveFilters();
      self.buildFilters();
      self.applyFilters();
    });
  };

  WishlistPage.prototype.filterDefinitions = function () {
  return [
    {
      key: 'size',
      label: 'Size',
      region: 'before-price'
    },
    {
      key: 'color',
      label: 'Color',
      region: 'after-price'
    },
    {
      key: 'availability',
      label: 'Availability',
      region: 'after-price'
    },
    {
      key: 'category',
      label: 'Category',
      region: 'after-price'
    }
  ];
};

WishlistPage.prototype.availableValues = function (key) {
  var values = [];

  this.entries.forEach(function (entry) {
    values.push.apply(
      values,
      entry.filters[key] || []
    );
  });

  values = unique(values);

  if (key === 'size') {
    return values.sort(compareSizes);
  }

  return values.sort(compareStrings);
};

  WishlistPage.prototype.pruneActiveFilters = function () {
    var self = this;

    Object.keys(this.activeFilters).forEach(function (key) {
      var available = self.availableValues(key);
      var selected = self.activeFilters[key];

      selected.forEach(function (value) {
        if (available.indexOf(value) === -1) selected.delete(value);
      });

      if (!selected.size) delete self.activeFilters[key];
    });
  };

WishlistPage.prototype.buildFilters =
  function () {
    var self = this;

    var filterRegions = [
  this.dynamicFiltersBeforePrice,
  this.dynamicFiltersAfterPrice
].filter(Boolean);

var openKeys = [];

filterRegions.forEach(function (region) {
  Array.from(
    region.querySelectorAll(
      'details[open][data-wlp-filter-key]'
    )
  ).forEach(function (detail) {
    openKeys.push(
      detail.dataset.wlpFilterKey
    );
  });
});

filterRegions.forEach(function (region) {
  region.innerHTML = '';
});

    this.filterDefinitions().forEach(
      function (definition) {
        var values =
          self.availableValues(
            definition.key
          );

        if (!values.length) return;

        var details =
          document.createElement(
            'details'
          );

        details.className =
          'ccf__accordion';

        details.dataset.wlpFilterAccordion =
          definition.key;

        details.dataset.wlpFilterKey =
          definition.key;

        if (
          openKeys.indexOf(
            definition.key
          ) !== -1
        ) {
          details.open = true;
        }

        var selected =
          self.activeFilters[
            definition.key
          ] || new Set();

        var choices = values
          .map(function (
            value,
            index
          ) {
            var id =
              'WishlistFilter-' +
              self.root.dataset.sectionId +
              '-' +
              definition.key +
              '-' +
              index;

            var colorSwatch =
              definition.key === 'color'
                ? [
                    '<span class="ccf__color-swatch" aria-hidden="true">',
                    '<span class="ccf__fallback-color-swatch" data-color-name="',
                    escapeHtml(
                      String(value).toLowerCase()
                    ),
                    '"></span>',
                    '</span>'
                  ].join('')
                : '';

            return [
              '<label class="ccf__choice',
              definition.key === 'color'
                ? ' ccf__choice--color'
                : '',
              '" for="',
              escapeHtml(id),
              '">',

              '<input id="',
              escapeHtml(id),
              '" type="checkbox"',
              ' class="ccf__choice-input"',
              ' data-wlp-filter-input',
              ' data-filter-key="',
              escapeHtml(
                definition.key
              ),
              '" value="',
              escapeHtml(value),
              '"',
              selected.has(value)
                ? ' checked'
                : '',
              '>',

              '<span class="ccf__checkbox" aria-hidden="true"></span>',

              colorSwatch,

              '<span class="ccf__choice-label">',
              escapeHtml(value),
              '</span>',

              '</label>'
            ].join('');
          })
          .join('');

        details.innerHTML = [
          '<summary class="ccf__summary">',

          '<span class="ccf__summary-content">',

          '<span class="ccf__title">',
          escapeHtml(
            definition.label
          ),

          '<span class="ccf__selected-count"',
          ' data-wlp-filter-count="',
          escapeHtml(
            definition.key
          ),
          '">',

          selected.size
            ? ' (' + selected.size + ')'
            : '',

          '</span>',
          '</span>',
          '</span>',

          '<span class="ccf__chevron" aria-hidden="true"></span>',

          '</summary>',

          '<div class="ccf__content">',
          '<div class="ccf__choices">',
          choices,
          '</div>',
          '</div>'
        ].join('');

var targetRegion =
  definition.region === 'before-price'
    ? self.dynamicFiltersBeforePrice
    : self.dynamicFiltersAfterPrice;

if (targetRegion) {
  targetRegion.appendChild(details);
}
      }
    );
  };

  WishlistPage.prototype.filteredEntries = function () {
    var self = this;
    var minimum = this.priceMin.value === '' ? null : Number(this.priceMin.value) * 100;
    var maximum = this.priceMax.value === '' ? null : Number(this.priceMax.value) * 100;

    var filtered = this.entries.filter(function (entry) {
      var matchesGroups = Object.keys(self.activeFilters).every(function (key) {
        var selected = self.activeFilters[key];
        if (!selected || !selected.size) return true;

        var values = entry.filters[key] || [];
        return Array.from(selected).some(function (value) {
          return values.indexOf(value) !== -1;
        });
      });

      if (!matchesGroups) return false;

      var price = Number(entry.variant.price || 0);
      if (minimum != null && price < minimum) return false;
      if (maximum != null && price > maximum) return false;
      return true;
    });

    filtered.sort(function (a, b) {
      if (self.sort === 'price-ascending') {
        return Number(a.variant.price || 0) - Number(b.variant.price || 0);
      }

      if (self.sort === 'price-descending') {
        return Number(b.variant.price || 0) - Number(a.variant.price || 0);
      }

      if (self.sort === 'newest') {
        var aDate = Date.parse(a.product.published_at || a.product.created_at || 0) || 0;
        var bDate = Date.parse(b.product.published_at || b.product.created_at || 0) || 0;
        return bDate - aDate || a.originalIndex - b.originalIndex;
      }

      return a.originalIndex - b.originalIndex;
    });

    return filtered;
  };

  WishlistPage.prototype.applyFilters = function () {
    var entries = this.filteredEntries();
    this.updateCount(entries.length);
    this.updateFilterSummaries();
    this.updateClearButton();

    if (!this.entries.length) {
      this.grid.innerHTML = '';
      this.setState('empty');
      return;
    }

    if (!entries.length) {
      this.grid.innerHTML = '';
      this.setState('no-results');
      return;
    }

    this.grid.innerHTML = '';
    entries.forEach(
      function (entry) {
        this.grid.appendChild(this.createCard(entry));
      }.bind(this)
    );

    this.setState('grid');
  };
  WishlistPage.prototype.renderActiveFilters =
  function () {
    if (!this.activeFilterBar) {
      return;
    }

    var pills = [];

    Object.keys(
      this.activeFilters
    ).forEach(
      function (key) {
        var selected =
          this.activeFilters[key];

        if (!selected) return;

        selected.forEach(
          function (value) {
            var swatch =
              key === 'color'
                ? [
                    '<span class="ccf__active-filter-swatch" aria-hidden="true">',
                    '<span class="ccf__fallback-color-swatch" data-color-name="',
                    escapeHtml(
                      String(value).toLowerCase()
                    ),
                    '"></span>',
                    '</span>'
                  ].join('')
                : '';

            pills.push(
              [
                '<button',
                ' type="button"',
                ' class="ccf__active-filter"',
                ' data-wlp-remove-filter',
                ' data-filter-key="',
                escapeHtml(key),
                '"',
                ' data-filter-value="',
                escapeHtml(value),
                '"',
                ' role="listitem"',
                '>',

                swatch,

                '<span>',
                escapeHtml(value),
                '</span>',

                '<span class="ccf__active-filter-remove" aria-hidden="true">×</span>',

                '<span class="visually-hidden">Remove ',
                escapeHtml(value),
                ' filter</span>',

                '</button>'
              ].join('')
            );
          }
        );
      }.bind(this)
    );

    var minimum =
      this.priceMin.value;

    var maximum =
      this.priceMax.value;

    if (
      minimum !== '' ||
      maximum !== ''
    ) {
      var priceLabel = '';

      if (
        minimum !== '' &&
        maximum !== ''
      ) {
        priceLabel =
          money(
            Number(minimum) * 100
          ) +
          ' – ' +
          money(
            Number(maximum) * 100
          );
      } else if (minimum !== '') {
        priceLabel =
          money(
            Number(minimum) * 100
          ) + '+';
      } else {
        priceLabel =
          'Up to ' +
          money(
            Number(maximum) * 100
          );
      }

      pills.push(
        [
          '<button',
          ' type="button"',
          ' class="ccf__active-filter"',
          ' data-wlp-remove-price',
          ' role="listitem"',
          '>',

          '<span>',
          escapeHtml(priceLabel),
          '</span>',

          '<span class="ccf__active-filter-remove" aria-hidden="true">×</span>',

          '<span class="visually-hidden">Remove price filter</span>',

          '</button>'
        ].join('')
      );
    }

    this.activeFilterBar.innerHTML =
      pills.join('');

    this.activeFilterBar.hidden =
      pills.length === 0;
  };

WishlistPage.prototype.updateFilterSummaries =
  function () {
    var self = this;

    this.root
      .querySelectorAll(
        '[data-wlp-filter-count]'
      )
      .forEach(function (count) {
        var key =
          count.dataset.wlpFilterCount;

        var values =
          self.activeFilters[key] ||
          new Set();

        count.textContent =
          values.size
            ? ' (' + values.size + ')'
            : '';
      });

    var hasPrice =
      this.priceMin.value !== '' ||
      this.priceMax.value !== '';

    if (this.priceCount) {
      this.priceCount.textContent =
        hasPrice ? ' (1)' : '';
    }

    this.renderActiveFilters();
  };
  WishlistPage.prototype.hasActiveFilters = function () {
    var hasChoices = Object.keys(this.activeFilters).some(
      function (key) {
        return this.activeFilters[key] && this.activeFilters[key].size;
      }.bind(this)
    );

    return hasChoices || this.priceMin.value !== '' || this.priceMax.value !== '' || this.sort !== 'relevance';
  };

  WishlistPage.prototype.updateClearButton = function () {
    var active = this.hasActiveFilters();
    this.clearButton.disabled = !active;
    this.clearButton.setAttribute('aria-disabled', active ? 'false' : 'true');
    this.clearButton.classList.toggle('ccf__clear-all--active', active);
  };

  WishlistPage.prototype.resetFilters = function (render) {
    this.activeFilters = Object.create(null);
    this.sort = 'relevance';
    this.priceMin.value = '';
    this.priceMax.value = '';

    this.root.querySelectorAll('[data-wlp-filter-input]').forEach(function (input) {
      input.checked = false;
    });

    var relevance = this.root.querySelector('.ccf__sort-input[value="relevance"]');
    if (relevance) relevance.checked = true;
    this.root
  .querySelectorAll('[data-cmc-mobile-sort-input]')
  .forEach(function (input) {
    input.checked = input.value === 'relevance';
  });

    if (render !== false) this.applyFilters();
  };

  WishlistPage.prototype.createCard = function (entry) {
    var product = entry.product;
    var variant = entry.variant;
    var label = productLabel(product);
    var sizeData = getSizeData(product, variant);
    var productImage = imageUrl(
  variant.featured_image ||
  variant.image ||
  product.featured_image
);

var secondaryProductImage = imageUrl(
  (product.images || [])[1]
);

var article = document.createElement('article');
    var optionsHtml = '';

    sizeData.choices.forEach(function (choiceVariant, choiceLabel) {
      var selected = String(choiceVariant.id) === String(variant.id) ? ' selected' : '';
      var unavailable = choiceVariant.available === false;

      optionsHtml +=
        '<option value="' +
        escapeHtml(choiceVariant.id) +
        '"' +
        selected +
        (unavailable ? ' disabled' : '') +
        '>' +
        escapeHtml(choiceLabel) +
        (unavailable ? ' — Out of stock' : '') +
        '</option>';
    });

    article.className =
  'wlp-card' +
  (
    secondaryProductImage
      ? ' wlp-card--has-secondary'
      : ''
  );
    article.dataset.productHandle = product.handle;
    article.dataset.variantId = String(variant.id);

    article.innerHTML = [
      '<div class="wlp-card__media">',
      '<a class="wlp-card__image-link" href="' + productUrl(product.handle) + '">',
productImage
  ? [
      '<img',
      ' class="wlp-card__image wlp-card__image--primary"',
      ' src="',
      escapeHtml(productImage),
      '"',
      ' alt="',
      escapeHtml(product.title || ''),
      '"',
      ' loading="lazy"',
      '>',

      secondaryProductImage
        ? [
            '<img',
            ' class="wlp-card__image wlp-card__image--secondary"',
            ' src="',
            escapeHtml(secondaryProductImage),
            '"',
            ' alt=""',
            ' aria-hidden="true"',
            ' loading="lazy"',
            '>'
          ].join('')
        : ''
    ].join('')
  : '<span class="wlp-card__placeholder"></span>',
      '</a>',
      '<button type="button" class="wlp-card__heart" data-wlp-remove data-product-handle="' +
        escapeHtml(product.handle) +
        '" aria-label="Remove ' +
        escapeHtml(product.title || '') +
        ' from wishlist">',
      heartIcon(),
      '</button>',
      label.text
        ? '<span class="wlp-card__label' +
          (label.soldOut ? ' wlp-card__label--sold-out' : '') +
          '">' +
          escapeHtml(label.text) +
          '</span>'
        : '',
      '</div>',
      '<div class="wlp-card__body">',
      '<div class="wlp-card__title-row">',
      '<a class="wlp-card__title" href="' + productUrl(product.handle) + '">' + escapeHtml(product.title || '') + '</a>',
      '<button type="button" class="wlp-card__menu-toggle" data-wlp-menu-toggle aria-label="More options" aria-expanded="false">•••</button>',
      '</div>',
      '<div class="wlp-card__meta" data-wlp-meta>' +
  escapeHtml(
    productCategoryColour(
      product,
      variant
    )
  ) +
  '</div>',
      '<div class="wlp-card__price" data-wlp-price>' + money(variant.price) + '</div>',
      '<div class="wlp-card__actions">',
      '<label class="wlp-card__size-wrap">',
      '<span class="visually-hidden">Select size for ' + escapeHtml(product.title || '') + '</span>',
      '<select class="wlp-card__size-select" data-wlp-size-select data-product-handle="' +
        escapeHtml(product.handle) +
        '">' +
        optionsHtml +
        '</select>',
      '</label>',
      '<button type="button" class="wlp-card__bag" data-wlp-add-to-cart data-variant-id="' +
        escapeHtml(variant.id) +
        '" aria-label="Add ' +
        escapeHtml(product.title || '') +
        ' to bag"' +
        (variant.available === false ? ' disabled' : '') +
        '>',
      bagIcon(),
      '</button>',
      '</div>',
      '<div class="wlp-card__menu" data-wlp-menu hidden>',
      '<button type="button" data-wlp-menu-add>',
      menuBagIcon(),
      '<span>Add to bag</span>',
      '</button>',
      '<button type="button" class="is-danger" data-wlp-remove data-product-handle="' +
        escapeHtml(product.handle) +
        '">',
      trashIcon(),
      '<span>Remove from wishlist</span>',
      '</button>',
      '</div>',
      '</div>'
    ].join('');

    return article;
  };

  WishlistPage.prototype.closeMenus = function (except) {
    this.root.querySelectorAll('[data-wlp-menu]').forEach(function (menu) {
      if (menu !== except) menu.hidden = true;
    });

    this.root.querySelectorAll('[data-wlp-menu-toggle]').forEach(function (button) {
      var card = button.closest('.wlp-card');
      var menu = card ? card.querySelector('[data-wlp-menu]') : null;
      if (!except || menu !== except) button.setAttribute('aria-expanded', 'false');
    });
  };

  WishlistPage.prototype.removeItem = function (handle) {
    var api = window.CartWishlistDrawer;

    if (api && typeof api.removeItem === 'function') {
      api.removeItem(handle);
      return;
    }

    var items = readStoredItems().filter(function (item) {
      return item.handle !== handle;
    });

    window.localStorage.setItem(storageKey, JSON.stringify(items));
    document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { items: items } }));
  };

WishlistPage.prototype.addToCart = function (
  variantId,
  button
) {
  var api =
    window.CartWishlistDrawer;

  if (
    !variantId ||
    !button ||
    button.getAttribute('aria-busy') ===
      'true'
  ) {
    return Promise.resolve();
  }

  var originalLabel =
    button.getAttribute('aria-label') ||
    'Add to bag';

  button.disabled = true;

  button.classList.add(
    'is-loading'
  );

  button.setAttribute(
    'aria-busy',
    'true'
  );

  button.setAttribute(
    'aria-label',
    'Adding to bag'
  );

  var request;

  try {
    if (
      api &&
      typeof api.addVariantToCart ===
        'function'
    ) {
      request =
        api.addVariantToCart(
          variantId,
          button
        );
    } else {
      window.location.href =
        rootUrl() +
        'cart/add?id=' +
        encodeURIComponent(
          variantId
        ) +
        '&quantity=1';

      return Promise.resolve();
    }
  } catch (error) {
    request =
      Promise.reject(error);
  }

  return Promise.resolve(
    request
  ).finally(function () {
    if (!button.isConnected) {
      return;
    }

    button.classList.remove(
      'is-loading'
    );

    button.removeAttribute(
      'aria-busy'
    );

    button.setAttribute(
      'aria-label',
      originalLabel
    );

    button.disabled = false;
  });
};

  WishlistPage.prototype.updateStoredVariant = function (handle, variantId) {
    var api = window.CartWishlistDrawer;

    if (api && typeof api.setItemVariant === 'function') {
      api.setItemVariant(handle, variantId);
      return;
    }

    var items = readStoredItems();
    var item = items.find(function (entry) {
      return entry.handle === handle;
    });

    if (!item) return;
    item.variantId = String(variantId);
    window.localStorage.setItem(storageKey, JSON.stringify(items));
    document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { items: items } }));
  };

  WishlistPage.prototype.onClick = function (event) {
    var removeFilter =
  event.target.closest(
    '[data-wlp-remove-filter]'
  );

if (
  removeFilter &&
  this.root.contains(removeFilter)
) {
  event.preventDefault();

  var filterKey =
    removeFilter.dataset.filterKey;

  var filterValue =
    removeFilter.dataset.filterValue;

  var selected =
    this.activeFilters[
      filterKey
    ];

  if (selected) {
    selected.delete(
      filterValue
    );

    if (!selected.size) {
      delete this.activeFilters[
        filterKey
      ];
    }
  }

  this.root
    .querySelectorAll(
      '[data-wlp-filter-input]'
    )
    .forEach(function (input) {
      if (
        input.dataset.filterKey ===
          filterKey &&
        input.value ===
          filterValue
      ) {
        input.checked = false;
      }
    });

  this.applyFilters();
  return;
}

var removePrice =
  event.target.closest(
    '[data-wlp-remove-price]'
  );

if (
  removePrice &&
  this.root.contains(removePrice)
) {
  event.preventDefault();

  this.priceMin.value = '';
  this.priceMax.value = '';

  this.applyFilters();
  return;
}
    var clear = event.target.closest('[data-wlp-clear-all], [data-wlp-clear-no-results]');
    if (clear && this.root.contains(clear)) {
      event.preventDefault();
      this.resetFilters();
      return;
    }

    var menuToggle = event.target.closest('[data-wlp-menu-toggle]');
    if (menuToggle && this.root.contains(menuToggle)) {
      event.preventDefault();
      event.stopPropagation();

      var card = menuToggle.closest('.wlp-card');
      var menu = card ? card.querySelector('[data-wlp-menu]') : null;
      if (!menu) return;

      var open = menu.hidden;
      this.closeMenus(menu);
      menu.hidden = !open;
      menuToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      return;
    }

    var remove = event.target.closest('[data-wlp-remove]');
    if (remove && this.root.contains(remove)) {
      event.preventDefault();
      event.stopPropagation();
      this.closeMenus();
      this.removeItem(remove.dataset.productHandle);
      return;
    }

    var menuAdd = event.target.closest('[data-wlp-menu-add]');
    if (menuAdd && this.root.contains(menuAdd)) {
      event.preventDefault();
      event.stopPropagation();

      var menuCard = menuAdd.closest('.wlp-card');
      var menuBag = menuCard ? menuCard.querySelector('[data-wlp-add-to-cart]') : null;
      if (menuBag) {
  this.addToCart(
    menuBag.dataset.variantId,
    menuBag
  );
}
      this.closeMenus();
      return;
    }

    var add = event.target.closest('[data-wlp-add-to-cart]');
    if (add && this.root.contains(add)) {
      event.preventDefault();
      event.stopPropagation();
      this.addToCart(add.dataset.variantId, add);
    }
  };

  WishlistPage.prototype.onDocumentClick = function (event) {
    if (!event.target.closest('[data-wlp-menu], [data-wlp-menu-toggle]')) this.closeMenus();
  };

  WishlistPage.prototype.onChange = function (event) {
    var sortInput = event.target.closest('.ccf__sort-input');
if (sortInput && this.root.contains(sortInput)) {
  this.sort = sortInput.value;

  this.root
    .querySelectorAll('[data-cmc-mobile-sort-input]')
    .forEach(
      function (input) {
        input.checked = input.value === this.sort;
      }.bind(this)
    );

  this.applyFilters();
  return;
}

    var filterInput = event.target.closest('[data-wlp-filter-input]');
    if (filterInput && this.root.contains(filterInput)) {
      var key = filterInput.dataset.filterKey;
      var selected = (this.activeFilters[key] ||= new Set());

      if (filterInput.checked) selected.add(filterInput.value);
      else selected.delete(filterInput.value);

      if (!selected.size) delete this.activeFilters[key];
      this.applyFilters();
      return;
    }

    var select = event.target.closest('[data-wlp-size-select]');
    if (select && this.root.contains(select)) {
      var card = select.closest('.wlp-card');
      var handle = select.dataset.productHandle;
      var variantId = select.value;
      var entry = this.entries.find(function (candidate) {
        return candidate.product.handle === handle;
      });

      if (!entry || !card) return;

      var variant = variantById(entry.product, variantId);
      if (!variant) return;

      entry.variant = variant;
      entry.item.variantId = String(variant.id);
      card.dataset.variantId = String(variant.id);

      var price = card.querySelector('[data-wlp-price]');
      if (price) price.textContent = money(variant.price);

      var meta = card.querySelector(
  '[data-wlp-meta]'
);

if (meta) {
  meta.textContent =
    productCategoryColour(
      entry.product,
      variant
    );
}

      var image = card.querySelector(
  '.wlp-card__image--primary'
);
      var nextImage = imageUrl(variant.featured_image || variant.image || entry.product.featured_image);
      if (image && nextImage) image.src = nextImage;

      var bag = card.querySelector('[data-wlp-add-to-cart]');
      if (bag) {
        bag.dataset.variantId = String(variant.id);
        bag.disabled = variant.available === false;
      }

      this.updateStoredVariant(handle, variant.id);
    }
  };

  WishlistPage.prototype.onInput = function (event) {
    if (!event.target.matches('[data-wlp-price-min], [data-wlp-price-max]')) return;

    window.clearTimeout(this.priceTimer);
    this.priceTimer = window.setTimeout(
      function () {
        this.applyFilters();
      }.bind(this),
      180
    );
  };

  WishlistPage.prototype.onKeyDown = function (event) {
    if (event.key === 'Escape') this.closeMenus();
  };

  WishlistPage.prototype.onWishlistUpdate = function () {
    this.refresh();
  };

  WishlistPage.prototype.onStorage = function (event) {
    if (event.key === storageKey) this.refresh();
  };

       if (!customElements.get('aac-mobile-wishlist-ui')) {
        const stateStore = (window.__aacMobileWishlistState ||= {});

        class AACMobileWishlistUI extends HTMLElement {
          constructor() {
            super();
            this.activeSheet = null;
            this.lastTrigger = null;
            this.closeTimer = null;
            this.drag = null;
            this.mediaQuery = window.matchMedia('(max-width: 989px)');

            this.onClick = this.onClick.bind(this);
            this.onChange = this.onChange.bind(this);
            this.onKeyDown = this.onKeyDown.bind(this);
            this.onToggle = this.onToggle.bind(this);
            this.onMediaChange = this.onMediaChange.bind(this);
            this.onPointerDown = this.onPointerDown.bind(this);
            this.onPointerMove = this.onPointerMove.bind(this);
            this.onPointerUp = this.onPointerUp.bind(this);
          }

          connectedCallback() {
            if (this.dataset.mobileUiInitialized === 'true') return;
            this.dataset.mobileUiInitialized = 'true';

            this.sectionId = this.dataset.sectionId || '';
            this.state = stateStore[this.sectionId] ||= {
              sheet: null,
              openAccordions: null,
            };

            this.cacheElements();
            this.restoreAccordions();

            this.addEventListener('click', this.onClick);
            this.addEventListener('change', this.onChange);
            this.addEventListener('toggle', this.onToggle, true);
            this.addEventListener('pointerdown', this.onPointerDown);
            document.addEventListener('keydown', this.onKeyDown);
            this.mediaQuery.addEventListener('change', this.onMediaChange);

            if (this.mediaQuery.matches) {
              if (this.state.sheet) {
                requestAnimationFrame(() => this.openSheet(this.state.sheet, null, true));
              } else {
                this.syncMobileClosedAccessibility();
              }
            } else {
              this.syncDesktopAccessibility();
            }
          }

          disconnectedCallback() {
            this.removeEventListener('click', this.onClick);
            this.removeEventListener('change', this.onChange);
            this.removeEventListener('toggle', this.onToggle, true);
            this.removeEventListener('pointerdown', this.onPointerDown);
            document.removeEventListener('keydown', this.onKeyDown);
            document.removeEventListener('pointermove', this.onPointerMove);
            document.removeEventListener('pointerup', this.onPointerUp);
            document.removeEventListener('pointercancel', this.onPointerUp);
            this.mediaQuery.removeEventListener('change', this.onMediaChange);

            window.setTimeout(() => {
              if (!document.querySelector('aac-mobile-wishlist-ui .is-open')) {
                AACMobileWishlistUI.unlockPage();
              }
            }, 40);
          }

          cacheElements() {
            this.toolbar = this.querySelector('[data-cmc-mobile-toolbar]');
            this.sortButton = this.querySelector('[data-cmc-open-sort]');
            this.filterButton = this.querySelector('[data-cmc-open-filter]');
            this.backdrop = this.querySelector('[data-cmc-mobile-backdrop]');
            this.sortSheet = this.querySelector('[data-cmc-sort-sheet]');
            this.filterSheet = this.querySelector('[data-cmc-filter-sheet]');
          }

          restoreAccordions() {
            const details = Array.from(this.querySelectorAll('[data-wlp-filter-accordion]'));

            if (!Array.isArray(this.state.openAccordions)) {
              this.state.openAccordions = details
                .filter((detail) => detail.open)
                .map((detail) => detail.dataset.wlpFilterAccordion)
                .filter(Boolean);
              return;
            }

            details.forEach((detail) => {
              const key = detail.dataset.wlpFilterAccordion;
              detail.open = key ? this.state.openAccordions.includes(key) : detail.open;
            });
          }

          onToggle(event) {
            if (!(event.target instanceof HTMLDetailsElement)) return;
            if (!event.target.matches('[data-wlp-filter-accordion]')) return;

            this.state.openAccordions = Array.from(this.querySelectorAll('[data-wlp-filter-accordion][open]'))
              .map((detail) => detail.dataset.wlpFilterAccordion)
              .filter(Boolean);
          }

          onClick(event) {
            const sortTrigger = event.target.closest('[data-cmc-open-sort]');
            const filterTrigger = event.target.closest('[data-cmc-open-filter]');
            const closeTrigger = event.target.closest('[data-cmc-close-sheet]');
            const backdrop = event.target.closest('[data-cmc-mobile-backdrop]');

            if (sortTrigger && this.contains(sortTrigger)) {
              this.openSheet('sort', sortTrigger);
              return;
            }

            if (filterTrigger && this.contains(filterTrigger)) {
              this.openSheet('filter', filterTrigger);
              return;
            }

            if ((closeTrigger && this.contains(closeTrigger)) || (backdrop && this.contains(backdrop))) {
              this.closeSheet();
            }
          }

          onChange(event) {
            const mobileSortInput = event.target.closest('[data-cmc-mobile-sort-input]');
            if (!(mobileSortInput instanceof HTMLInputElement)) return;

            const sourceInput = Array.from(this.querySelectorAll('.ccf__sort-input')).find(
              (input) => input.value === mobileSortInput.value
            );

            if (!(sourceInput instanceof HTMLInputElement)) return;

            sourceInput.checked = true;
            this.state.sheet = null;
            this.closeSheet(false);
            sourceInput.dispatchEvent(new Event('change', { bubbles: true }));
          }

          onMediaChange(event) {
            if (!event.matches) {
              this.state.sheet = null;
              this.closeSheet(false, true);
              this.syncDesktopAccessibility();
            }
          }

          syncDesktopAccessibility() {
            if (!this.filterSheet) return;
            this.filterSheet.removeAttribute('role');
            this.filterSheet.removeAttribute('aria-modal');
            this.filterSheet.removeAttribute('aria-hidden');
          }

          syncMobileClosedAccessibility() {
            this.sortSheet?.setAttribute('aria-hidden', 'true');
            if (this.filterSheet) {
              this.filterSheet.setAttribute('role', 'dialog');
              this.filterSheet.setAttribute('aria-modal', 'true');
              this.filterSheet.setAttribute('aria-hidden', 'true');
            }
          }

          openSheet(type, trigger = null, restoring = false) {
            if (!this.mediaQuery.matches) return;

            this.cacheElements();
            const sheet = type === 'filter' ? this.filterSheet : this.sortSheet;
            if (!sheet) return;

            if (this.closeTimer) {
              window.clearTimeout(this.closeTimer);
              this.closeTimer = null;
            }

            this.lastTrigger = trigger || this.lastTrigger;
            this.activeSheet = type;
            this.state.sheet = type;

            if (this.backdrop) {
              this.backdrop.hidden = false;
              requestAnimationFrame(() => this.backdrop?.classList.add('is-visible'));
            }

            this.sortSheet?.classList.toggle('is-open', type === 'sort');
            this.filterSheet?.classList.toggle('is-open', type === 'filter');

            this.sortSheet?.setAttribute('aria-hidden', type === 'sort' ? 'false' : 'true');

            if (this.filterSheet) {
              if (type === 'filter') {
                this.filterSheet.setAttribute('role', 'dialog');
                this.filterSheet.setAttribute('aria-modal', 'true');
                this.filterSheet.setAttribute('aria-hidden', 'false');
              } else {
                this.filterSheet.setAttribute('aria-hidden', 'true');
              }
            }

            this.sortButton?.setAttribute('aria-expanded', type === 'sort' ? 'true' : 'false');
            this.filterButton?.setAttribute('aria-expanded', type === 'filter' ? 'true' : 'false');

            AACMobileWishlistUI.lockPage();

            if (!restoring) {
              requestAnimationFrame(() => {
                const focusTarget = sheet.querySelector(
                  '[data-cmc-close-sheet], input:not([disabled]), button:not([disabled]), summary'
                );
                focusTarget?.focus({ preventScroll: true });
              });
            }
          }

          closeSheet(returnFocus = true, immediate = false) {
            const trigger = this.lastTrigger;
            this.activeSheet = null;
            this.state.sheet = null;

            this.sortSheet?.classList.remove('is-open');
            this.filterSheet?.classList.remove('is-open');
            this.backdrop?.classList.remove('is-visible');
            this.sortSheet?.setAttribute('aria-hidden', 'true');

            if (this.filterSheet && this.mediaQuery.matches) {
              this.filterSheet.setAttribute('aria-hidden', 'true');
            }

            this.sortButton?.setAttribute('aria-expanded', 'false');
            this.filterButton?.setAttribute('aria-expanded', 'false');

            if (this.closeTimer) window.clearTimeout(this.closeTimer);

            const finish = () => {
              if (this.backdrop) this.backdrop.hidden = true;
              AACMobileWishlistUI.unlockPage();
              if (returnFocus && trigger?.isConnected) trigger.focus({ preventScroll: true });
            };

            if (immediate) {
              finish();
            } else {
              this.closeTimer = window.setTimeout(finish, 285);
            }
          }

          onKeyDown(event) {
            if (!this.activeSheet || !this.mediaQuery.matches) return;

            if (event.key === 'Escape') {
              event.preventDefault();
              this.closeSheet();
              return;
            }

            if (event.key !== 'Tab') return;

            const sheet = this.activeSheet === 'filter' ? this.filterSheet : this.sortSheet;
            if (!sheet) return;

            const focusable = Array.from(
              sheet.querySelectorAll(
                'button:not([disabled]), input:not([disabled]), summary, a[href], [tabindex]:not([tabindex="-1"])'
              )
            ).filter((element) => element.offsetParent !== null);

            if (!focusable.length) return;

            const first = focusable[0];
            const last = focusable[focusable.length - 1];

            if (event.shiftKey && document.activeElement === first) {
              event.preventDefault();
              last.focus();
            } else if (!event.shiftKey && document.activeElement === last) {
              event.preventDefault();
              first.focus();
            }
          }

          onPointerDown(event) {
            const handle = event.target.closest('[data-cmc-close-sheet]');
            if (!handle || !this.mediaQuery.matches) return;

            const sheet = handle.closest('[data-cmc-sort-sheet], [data-cmc-filter-sheet]');
            if (!sheet) return;

            this.drag = {
              pointerId: event.pointerId,
              startY: event.clientY,
              sheet,
            };

            handle.setPointerCapture?.(event.pointerId);
            document.addEventListener('pointermove', this.onPointerMove, { passive: false });
            document.addEventListener('pointerup', this.onPointerUp);
            document.addEventListener('pointercancel', this.onPointerUp);
          }

          onPointerMove(event) {
            if (!this.drag || event.pointerId !== this.drag.pointerId) return;
            const distance = Math.max(0, event.clientY - this.drag.startY);
            if (distance <= 0) return;

            event.preventDefault();
            this.drag.sheet.style.transition = 'none';
            this.drag.sheet.style.transform = `translateY(${distance}px)`;
          }

          onPointerUp(event) {
            if (!this.drag || event.pointerId !== this.drag.pointerId) return;

            const distance = Math.max(0, event.clientY - this.drag.startY);
            const sheet = this.drag.sheet;
            sheet.style.removeProperty('transition');
            sheet.style.removeProperty('transform');
            this.drag = null;

            document.removeEventListener('pointermove', this.onPointerMove);
            document.removeEventListener('pointerup', this.onPointerUp);
            document.removeEventListener('pointercancel', this.onPointerUp);

            if (distance > 80) this.closeSheet();
          }

          static lockPage() {
            if (document.documentElement.classList.contains('cmc-mobile-sheet-open')) return;

            const scrollY = window.scrollY;
            document.documentElement.dataset.cmcScrollY = String(scrollY);
            document.documentElement.classList.add('cmc-mobile-sheet-open');
            document.body.classList.add('cmc-mobile-sheet-open');
            document.body.style.position = 'fixed';
            document.body.style.top = `-${scrollY}px`;
            document.body.style.right = '0';
            document.body.style.left = '0';
            document.body.style.width = '100%';
          }

          static unlockPage() {
            if (!document.documentElement.classList.contains('cmc-mobile-sheet-open')) return;

            const scrollY = Number(document.documentElement.dataset.cmcScrollY || 0);
            document.documentElement.classList.remove('cmc-mobile-sheet-open');
            document.body.classList.remove('cmc-mobile-sheet-open');
            document.body.style.removeProperty('position');
            document.body.style.removeProperty('top');
            document.body.style.removeProperty('right');
            document.body.style.removeProperty('left');
            document.body.style.removeProperty('width');
            delete document.documentElement.dataset.cmcScrollY;
            window.scrollTo(0, scrollY);
          }
        }

customElements.define('aac-mobile-wishlist-ui', AACMobileWishlistUI);
}

function init() {
    document.querySelectorAll('[data-wishlist-page]').forEach(function (root) {
      if (root.dataset.wishlistPageInitialized === 'true') return;
      root.dataset.wishlistPageInitialized = 'true';
      root.__wishlistPage = new WishlistPage(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
